import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import SignalCellular4BarIcon from '@mui/icons-material/SignalCellular4Bar';
import SignalCellularAlt2BarIcon from '@mui/icons-material/SignalCellularAlt2Bar';
import SignalCellularAlt1BarIcon from '@mui/icons-material/SignalCellularAlt1Bar';
import SignalCellularConnectedNoInternet0BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet0Bar';
import { ConnectionQuality } from 'livekit-client';

function describe(quality) {
  switch (quality) {
    case ConnectionQuality.Excellent: return { label: 'Excellent', Icon: SignalCellular4BarIcon,     color: 'success' };
    case ConnectionQuality.Good:      return { label: 'Good',      Icon: SignalCellularAlt2BarIcon,  color: 'success' };
    case ConnectionQuality.Poor:      return { label: 'Poor',      Icon: SignalCellularAlt1BarIcon,  color: 'warning' };
    case ConnectionQuality.Lost:      return { label: 'Lost',      Icon: SignalCellularConnectedNoInternet0BarIcon, color: 'error' };
    default:                          return { label: 'Connecting…', Icon: SignalCellularAlt1BarIcon, color: 'default' };
  }
}

export default function ConnectionQualityBadge({ quality, connectionState }) {
  const { label, Icon, color } = describe(quality);
  const tooltip = connectionState
    ? `Connection: ${connectionState} · Quality: ${label}`
    : `Quality: ${label}`;

  return (
    <Tooltip title={tooltip}>
      <Chip
        icon={<Icon fontSize="small" />}
        label={label}
        size="small"
        color={color}
        variant="outlined"
      />
    </Tooltip>
  );
}
